import { SelectInputItem } from '@interfaces/global';

export const icons: [SelectInputItem<string>] = [
    { id: 'wheel',  name: 'wheel', }
];